// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"594":"about","692":"draft"}[chunkId] + "." + {"594":"8392aa01","692":"306b8d53"}[chunkId] + ".css";
};